"use client";

import { WagmiProvider as WagmiProviderComponent } from "wagmi";

import { config } from "@/lib/integrations/wagmi";

function WagmiProvider({ children }: React.PropsWithChildren) {
  return <WagmiProviderComponent config={config}>{children}</WagmiProviderComponent>;
}

export default WagmiProvider;
